import React, { useState, useEffect } from "react"; 
import { useParams } from "react-router-dom";
import PurchaseInvoiceLayout from "../components/PurchaseInvoiceLayout";
import PurchaseOrderForm from "../components/PurchaseOrderForm";
import ProductSearch from "../components/ProductSearch";
import { usePurchaseItems } from "../context/PurchaseItemsContext";
import { useAuthContext } from "../context/AuthContext";  // 追加

const PurchaseOrderPage = () => {
  const { id } = useParams(); // URLから `id` を取得
  const { user: userInfo } = useAuthContext(); // ユーザー情報から store_id を取得
  const [supportId, setSupportId] = useState(null);
  const [selectedStore, setSelectedStore] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const { setAndFetchPurchaseOrderId } = usePurchaseItems();

  useEffect(() => {
    if (id !== undefined) {
      setAndFetchPurchaseOrderId(id || null);  // null でも初期化処理される
    }
  }, [id, setAndFetchPurchaseOrderId]);

  useEffect(() => {
    if (userInfo?.store_id) {
      setSelectedStore(userInfo.store_id.toString());
    }
  }, [userInfo]);

  return (
    <PurchaseInvoiceLayout
      leftContent={<PurchaseOrderForm selectedStore={selectedStore} setSupportId={setSupportId} setSearchTerm={setSearchTerm} setSearchResults={setSearchResults}  />}
      rightContent={<ProductSearch selectedStore={selectedStore} supportId={supportId} setSupportId={setSupportId} setSearchTerm={setSearchTerm} searchTerm={searchTerm} searchResults={searchResults} setSearchResults={setSearchResults} />}
    />
  );
};

export default PurchaseOrderPage;
